import { type Channel } from "@slack/web-api/dist/types/response/UsersConversationsResponse";
import { List } from "immutable";
import { type TNotificationIntegrationType } from "models/NotificationIntegrationModel";
import { apiReq } from "utils/api/apiReq";
import { apiReqAbortOld } from "utils/api/apiReqAbortOld";
import { toMapBy } from "utils/toMapBy";

export type TSlackChannel = Channel & { id: string };

const isSlackChannel = (channel: Channel): channel is TSlackChannel => Boolean(channel.id);

const integrationType: TNotificationIntegrationType = "slack";

export const getSlackChannels = async () => {
  const { data } = (await apiReqAbortOld({
    key: "getSlackChannels",
    method: "GET",
    path: `/v1/chats/channels?integrationType=${integrationType}`,
  })) as { data: Channel[] | undefined };

  if (!data) return null;

  const channelsWithId = data.filter(isSlackChannel);
  return toMapBy(channelsWithId, (channel) => channel.id);
};

export const multiGetSlackChannels = async (
  ids: string[],
  options: { suppressError?: boolean; withArchived?: boolean } = {},
) => {
  if (!ids.length) return List<TSlackChannel>();

  const { data } = await apiReq<Channel[] | undefined>(
    "GET",
    `/v1/chats/channels/multiGet?integrationType=${integrationType}&withArchived=${Boolean(options.withArchived)}&${ids.map((id) => "ids=" + id).join("&")}`,
    null,
    { suppressError: options.suppressError },
  );

  const channelsWithId = data?.filter(isSlackChannel);
  return List(channelsWithId);
};
